import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomInitialConsecutiveComponent } from 'src/app/components/custom-initial-consecutive/custom-initial-consecutive.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { RemissionPrintModel } from 'src/app/models/print/rental/remission-print.model';
import { TransporterService } from 'src/app/services/archive/transporter.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { InvoicingCutoffService } from 'src/app/services/invoicing/invoicing-cutoff.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { FreightService } from 'src/app/services/management/freight.service';
import { RemissionDetailService } from 'src/app/services/rental/remission-detail.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { ServiceService } from 'src/app/services/rental/service.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RemissionStateEnums } from '../../../../enum/remission-state-enums';
import { BranchEnums } from './../../../../enum/branch-enums';
import { RemissionModel } from './../../../../models/rental/remission.model';
import { VehicleService } from './../../../../services/archive/vehicle.service';
import { RemissionService } from './../../../../services/rental/remission.service';

@Component({
  selector: 'app-register-remission',
  templateUrl: './register-remission.component.html',
  styleUrls: ['./register-remission.component.scss'],
  standalone: false
})
export class RegisterRemissionComponent implements OnInit, OnDestroy {
  @ViewChild('attachFileRemission') attachFileRemissionComponent?: CustomModalComponent | null = null;
  @ViewChild('initialConsecutive') initialConsecutiveModalComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  companyId: number = 0;
  constructionSiteStateId: number = 0;
  clientId: number = 0;
  clientStateActive: number = ClientStateEnums.activo;
  clientStateId: number = 0;
  componentAttachFiles = CustomAttachFilesComponent;
  componentInitialConsecutiveModal = CustomInitialConsecutiveComponent;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  finishLoadingPrint: boolean = false;
  filteredCostCenters: any[] = [];
  formRemission: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  mainBranchByUser: BranchModel = new BranchModel();
  iconState: string = "pi pi-lock-open";
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  remissionContract: RemissionModel = new RemissionModel();
  remissionPrintModel: RemissionPrintModel = new RemissionPrintModel();
  remissionId: number = 0;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listCostCenters: any[] = [];
  listClients: any[] = [];
  listFiles: any[] = [];
  listTransporters: any[] = [];
  listVehicles: any[] = [];
  listDelayReasons: any[] = [];
  listTypeAvailabilitys: any[] = [];
  listTypeRequirements: any[] = [];
  listUsersApp: any[] = [];
  listUsersAppSource: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  nameWindow: string = 'Captura Remisiones';
  titleState: string = "";
  transporterId: number = 0;
  outputForAttachFiles$ = new Subject<any>();
  outputForInitialConsecutive$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  permissionPrint: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  swAppMovil: boolean = false;
  swModuleOrder: boolean = false;
  swFreight: boolean = false;
  swIncludeStore: boolean = false;
  swIndicators: boolean = false;
  stateText: string = 'Abierta';
  url: string = "remission";
  userAuthenticated: UserModel = new UserModel();
  disabledState: boolean = false;
  dataPeriod: string | null = '';
  datePeriod: string | null = '';
  disabledBtnSave: boolean = true;
  invoicingCutoffCode: string = '';
  listType = BranchEnums.sucursalesUsuario;
  remissionStateString: string = '';
  remissionStateOpen: number = RemissionStateEnums.open;
  rentalPeriod: string = '';
  severityState: string = "danger";
  subscription: Subscription;
  stateClientId: number | null = 0;
  stateCostCenterId: number = 0;
  stateRentalPeriod: boolean = false;
  updateListDetail: boolean = false;
  visibleState: boolean = false;
  vehicleId: number = 0;

  //Variables para el control del modal de Precios C.Costos:
  openCostCenterPrice: CostCenterPriceModel = new CostCenterPriceModel(); //Esta variable para enviar al abrir el modal
  openCostCenterPriceRegister: boolean = false;
  openFromCostCenterPrice: string = "";
  costCenterPriceRegister: CostCenterPriceModel = new CostCenterPriceModel(); //Esta variable para recibir lo que envie el modal

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private formControlStateService: FormControlStateService,
    private formBuilder: UntypedFormBuilder,
    private formatService: FormatService,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private invoicingCutoffService: InvoicingCutoffService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private remissionService: RemissionService,
    private remissionDetailService: RemissionDetailService,
    private rentalPeriodService: RentalPeriodService,
    private freightService: FreightService,
    private router: Router,
    private serviceService: ServiceService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private transporterService: TransporterService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private vehicleService: VehicleService) { }

  async ngOnInit() {
    await this.validateForm(new RemissionModel());
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.remissionId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForInitialConsecutive$.subscribe(async ({ type, payload }) => {
      if (type === 'initialConsecutive') {
        this.formRemission.patchValue({
          consecutive: payload.consecutive
        });
        await this.send();
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  async annulRemission() {
    if (!this.validations()) return;

    if (this.remissionContract.isTransfer === true) {
      this.toastHandlerService.showToast('warning', 'Las remisiones de tipo traslado solo pueden anularse desde la pantalla de traslados entre obras.', 'Atención');
      return;
    }

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible anular, la remisión tiene detalle.', 'Atención');
      return;
    }

    if (!this.remissionContract.swBlock) {
      if (this.remissionContract.remissionId === RemissionStateEnums.annulled) {
        this.toastHandlerService.showToast('warning', 'La remisión se encuentra anulada.', 'Atención');
      } else {
        const accepted = await this.confirmDialogService.confirm(`¿Realmente desea anular la remisión actual?`);

        if (accepted) {
          try {
            this.remissionContract = await firstValueFrom(this.remissionService.annulRemission(this.remissionId));
            this.validateForm(this.remissionContract);
            this.toastHandlerService.showToast('success', 'La remisión fue anulada exitosamente.', '');
          } catch (error) {
            console.error("Error annuling service: ", error);
          }
        }
      }
    } else {
      this.toastHandlerService.showToast('warning', 'La remisión se encuentra bloqueada.', 'Atención');
    }
  }

  async blockRemission(value: boolean) {
    if (this.remissionContract.remissionStateId === this.remissionStateOpen) {
      this.toastHandlerService.showToast('warning', 'No es posible bloquear, la remisión se encuentra abierta.', 'Atención');
      await this.validateForm(this.remissionContract);
      return;
    }

    if (this.remissionContract.remissionId != 0 && this.remissionContract.remissionId != null) {
      const remissionId = this.remissionContract.remissionId;
      try {
        this.remissionContract = await firstValueFrom(this.remissionService.blockRemission(remissionId));
        await this.validateForm(this.remissionContract);
      } catch (error) {
        this.formRemission.controls["swBlock"].setValue(!value);
        console.error("Error al bloquear la remisión: ", error);
      }
    } else {
      this.formRemission.controls["swBlock"].setValue(!value);
      this.toastHandlerService.showToast('warning', 'Debe crear una remisión.', 'Atención');
      return;
    }
  }

  changeBranch() {
    const branchId = this.formRemission.get("branchId")?.value;
    this.remissionId = 0;
    const modelRemission = new RemissionModel();
    modelRemission.branchId = branchId;
  }

  async changeConsecutive() {
    const branchId = this.formRemission.get("branchId")?.value;
    let consecutive = this.formRemission.get("consecutive")?.value;

    if (this.remissionContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetRemission(branchId);
      return;
    }

    try {
      this.remissionContract = await firstValueFrom(this.remissionService.getRemissionByKeysAsync(branchId, consecutive));
      this.remissionId = this.remissionContract.remissionId;
      await this.validateForm(this.remissionContract);
      this.location.replaceState(`/remission/register/${this.remissionId}`);
    } catch (error) {
      this.formRemission.controls["consecutive"].setValue(this.remissionContract.consecutive);
      console.error('Error al buscar la remisión por campos de recuperación.', error);
    }
  }

  changeDateInvoice() {
    // Habilitara solo el Btn Guardar segun haga cambios en la fecha de factura
    this.disabledBtnSave = false;
    this.changeValues();
  }

  changeDateRemission() {
    const dateRemission = this.formRemission.get("dateRemission")?.value;
    this.formRemission.controls["dateInvoice"].patchValue(dateRemission);
    this.disabledDetail = true;
    this.disabledState = true;
    setTimeout(() => this.formRemission.controls["swBlock"].disable(), 100);
  }

  async changeState() {
    if (!this.validations()) return;
    if (this.remissionContract.swBlock) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible modificar el estado, la remisión se encuentra bloqueada.'
      );
      return;
    }
    const quantityDetail = await this.getQuantityDetails();
    if (quantityDetail > 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible modificar el estado, existen artículos con cantidad en cero o negativo.'
      );
      return;
    }
    try {
      this.remissionContract = await firstValueFrom(this.remissionService.setStateRemission(this.remissionContract.remissionId));
      this.toastHandlerService.showToast(
        'success',
        'El estado de la remisión se modificó exitosamente.'
      );
      await this.validateForm(this.remissionContract);
    } catch (error) {
      console.error('Error al cambiar el estado de la remisión.', error);
    }
  }


  changeTransportValue() {
    const transportValue = this.formRemission.get("transportValue")?.value ?? 0;
    const swBlockControl = this.formRemission.get("swBlock");

    if (transportValue < 0) {
      this.toastHandlerService.showToast('warning', 'El valor ingresado no es válido.');
      return;
    }

    this.disabledDetail = this.disabledState = true;
    setTimeout(() => swBlockControl?.disable(), 100);
  }

  changeValues() {
    this.disabledDetail = true;
    this.disabledState = true;
    setTimeout(() => this.formRemission.controls["swBlock"].disable(), 100);
  }

  async deleteRemission() {
    if (!this.validations()) return;

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la remisión tiene detalle.', 'Atención');
      return;
    }

    const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar la remisión ${this.remissionContract.consecutive}?`);

    if (accepted) {
      try {
        await firstValueFrom(this.remissionService.deleteRemission(this.remissionContract.remissionId));
        this.toastHandlerService.showToast('success', 'La remisión fue eliminada exitosamente.', '');
        this.createNewRemission();
      } catch (error) {
        console.error('Error al eliminar la remisión.', error);
      }
    }
  }

  async createNewRemission() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear remisiones. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    this.remissionId = 0;
    this.remissionContract = new RemissionModel();
    this.remissionContract.branchId = this.branchId;
    this.remissionContract.vehicleId = this.vehicleId;
    this.remissionContract.transporterId = this.transporterId;
    this.quantityDetails = 0;
    this.invoicingCutoffCode = "";
    this.rentalPeriod = "";
    this.filteredCostCenters = this.listCostCenters;
    await this.validateForm(this.remissionContract);
    this.location.replaceState(`/remission/register`);
  }

  async deleteFile(file: any) {
    if (this.remissionContract.remissionId != 0) {
      const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar el adjunto seleccionado?`);

      if (accepted) {
        try {
          await firstValueFrom(this.remissionService.deleteFilesToRemission(this.remissionContract.remissionId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToRemission();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.remissionContract.remissionId != 0) {
      this.remissionService.downloadFileToRemission(this.remissionContract.remissionId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editRemission() {
    await this.getRemissionById();
    this.branchId = this.remissionContract.branchId;
    await this.getAllLists();
    await this.validateForm(this.remissionContract);
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }



  async handleInitialState() {
    if (this.remissionId !== null && this.remissionId !== 0) {
      await this.editRemission();
    } else {
      this.createNewRemission();
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'costCenters' | 'clients' | 'transporters' | 'vehicles'>
  ) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        costCenters: async () => {
          this.listCostCenters = await firstValueFrom(
            this.remissionService.getAllCostCenterForSelect(this.branchId)
          );
          this.filteredCostCenters = this.listCostCenters;
        },
        clients: async () => {
          this.listClients = await firstValueFrom(
            this.invoiceService.getAllClientsForSelectAsync()
          );
        },
        transporters: async () => {
          this.listTransporters = await firstValueFrom(
            this.remissionService.getAllTransporterForSelect(this.branchId)
          );
          const defaultTransporter = this.listTransporters.find(x => x.isDefault);
          if (defaultTransporter) {
            this.transporterId = defaultTransporter.value;
          }
        },
        vehicles: async () => {
          this.listVehicles = await firstValueFrom(
            this.remissionService.getAllVehicleForSelect(this.branchId)
          );
          const defaultVehicle = this.listVehicles.find((x: any) => x.isDefault);
          if (defaultVehicle) {
            this.vehicleId = defaultVehicle.value;
          }
        },
        typeRequirement: async () => {
          this.listTypeRequirements = await firstValueFrom(
            this.remissionService.getAllConceptsRequirementTypeForSelect()
          );
        },
        delayReason: async () => {
          this.listDelayReasons = await firstValueFrom(
            this.remissionService.getAllConceptsDelayReasonForSelect()
          );
        },
        typeAvailability: async () => {
          this.listTypeAvailabilitys = await firstValueFrom(
            this.remissionService.getAllConceptsTypeAvailabilityForSelect()
          );
        },
        usersApp: async () => {
          this.listUsersAppSource = await firstValueFrom(
            this.remissionService.getAllUsersAppForSelect()
          );
          this.setListUsersApp(this.remissionContract.userId);
        }
      };

      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        const promises = [
          lists.branches(),
          lists.costCenters(),
          lists.clients(),
          lists.transporters(),
          lists.vehicles(),
        ];

        if (this.swIndicators) {
          promises.push(
            lists.delayReason(),
            lists.typeAvailability(),
            lists.typeRequirement()
          );
        }

        if (this.swAppMovil) {
          promises.push(lists.usersApp());
        }

        await Promise.all(promises);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    this.formRemission.controls["branchId"].patchValue(validBranch);
    await this.getAllLists();
    if (reload) {
      this.createNewRemission();
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formRemission.get("consecutive")?.value;
    const branchId = this.formRemission.get("branchId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleRemissionNavigation(buttonClick, branchId, consecutive);
  }


  async getCostCenter(costCenterId: number | null, validate: boolean) {
    // Caso: limpiar centro de costos
    if (!costCenterId) {
      if (this.showErrorIfHasDetails('No puede limpiar el c.costos si la remisión tiene detalle.')) return;
      this.resetCostCenterFields();
      this.stateCostCenterId = ClientStateEnums.activo;
      return;
    }

    const costCenterOld = this.remissionContract.costCenterId;
    const costCenterModel = await firstValueFrom(this.serviceService.getCostCenterByIdAsync(costCenterId));

    if (costCenterOld !== costCenterModel.costCenterId && this.showErrorIfHasDetails('No puede cambiar el c.costos si la remisión tiene detalle.')) return;

    const exists = this.listCostCenters.some(c => c.value === costCenterId);
    if (!exists) {
      this.listCostCenters.push({
        clientId: costCenterModel.clientId,
        label: `${costCenterModel.code} - ${costCenterModel.name}`,
        value: costCenterId
      });
    }

    this.clientId = costCenterModel.clientId;
    await this.getClient(costCenterModel.clientId, false);

    // Actualiza valores
    this.stateCostCenterId = costCenterModel.constructionSiteStateId;
    this.formRemission.patchValue({
      swInvoiceM2: costCenterModel.swInvoiceM2 ? 'SI' : 'NO',
      unitValueM2: costCenterModel.unitValueM2,
      observationCostCenter: costCenterModel.observation,
      clientId: costCenterModel.clientId,
      costCenterId
    });

    // Validación de inactividad
    if (validate && costCenterModel.constructionSiteStateId === ConstructionSiteStateEnums.inactiva) {
      this.toastHandlerService.showToast('warning', 'El centro de costos seleccionado se encuentra inactivo.', 'Atención');
      this.resetCostCenterFields(null);
      this.resetClientFields(null);
      this.filteredCostCenters = this.listCostCenters.filter(x => x.value !== costCenterId);
    }
  }

  private resetCostCenterFields(costCenterId: number | null = null) {
    this.formRemission.patchValue({
      costCenterId,
      swInvoiceM2: 'NO',
      unitValueM2: 0,
      observationCostCenter: ''
    });
  }

  private resetClientFields(clientId: number | null = null) {
    this.formRemission.patchValue({
      clientId,
      costCenterId: null
    });
  }

  private showErrorIfHasDetails(message: string): boolean {
    if (this.quantityDetails !== 0) {
      this.toastHandlerService.showToast('warning', message, 'Error');
      return true;
    }
    return false;
  }

  async getClient(clientId: number | null, validate: boolean) {
    this.filterCostCenterByClientId(clientId);
    const clientOld = this.clientId;

    // Caso: limpiar cliente
    if (!clientId) {
      if (this.showErrorIfHasDetails('No puede limpiar el cliente si la remisión tiene detalle.')) return;
      this.clientId = 0;
      this.resetClientFields(null);
      this.getCostCenter(null, false);
      return;
    }

    if (clientOld !== clientId && this.showErrorIfHasDetails('No puede cambiar el cliente si la remisión tiene detalle.')) return;

    const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));

    // Validar inactividad
    if (client?.clientStateId === ClientStateEnums.inactivo && validate) {
      this.toastHandlerService.showToast('warning', 'El cliente seleccionado se encuentra inactivo.', 'Atención');
      this.stateClientId = client.clientStateId ?? null;
      this.resetClientFields(null);
      this.filteredCostCenters = this.listCostCenters;
      return;
    }

    if (!client) {
      if (this.showErrorIfHasDetails('Error al buscar el elemento, por favor refresque la página.')) return;
      this.resetClientFields(null);
      this.clientId = 0;
      this.stateClientId = ClientStateEnums.activo;
      this.getCostCenter(null, false);
      return;
    }

    // Asignar cliente
    this.clientId = clientId;
    this.stateClientId = client.clientStateId ?? null;
    if (!this.listClients.some(c => c.value === clientId)) {
      this.listClients.push({ label: client.label, value: clientId });
    }
    this.formRemission.patchValue({ clientId });

    // Si cambió el cliente, limpiar el c.costos
    if (clientOld && clientOld !== clientId) {
      this.getCostCenter(null, false);
    }
  }

  filterCostCenterByClientId(clientId: number | null) {
    if (clientId != null) {
      this.filteredCostCenters = this.listCostCenters.filter(cc => cc.clientId === clientId);
      const costCenterId = this.formRemission.get("costCenterId")?.value;
      const costCenterClient = this.listCostCenters.find(x => x.clientId === clientId);
      if (costCenterId && costCenterClient && costCenterClient.value !== costCenterId) {
        this.formRemission.patchValue({ costCenterId: null });
      }
    } else {
      this.filteredCostCenters = this.listCostCenters;
    }
  }

  private async handleRemissionNavigation(buttonClick: any, branchId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<RemissionModel>> = {
      first: () => firstValueFrom(this.remissionService.getFirstRemissionByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.remissionService.getPreviusRemissionByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.remissionService.getNextRemissionByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.remissionService.getLastRemissionByKeysAsync(branchId))
    };
    try {
      const action = actionMap[buttonClick.target.id];
      if (!action) {
        await this.resetRemission(branchId);
        return;
      }
      const remission = await action();
      this.remissionContract = remission;
      this.remissionId = remission.remissionId;
      await this.validateForm(remission);
      this.location.replaceState(`/remission/register/${this.remissionId}`);
    } catch (error) {
      console.error(`Error al buscar la remisión (${buttonClick.target.id}).`, error);
    }
  }

  getClass(selection: 'client' | 'costCenter'): string {
    const stateKey = selection === 'client' ? 'stateClientId' : 'stateCostCenterId';
    const newClass = this[stateKey] === ClientStateEnums.activo ? '' : 'state-inactive';
    return newClass;
  }

  getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (this.openFromCostCenterPrice == "createRemissionDetail") {
      this.costCenterPriceRegister = costCenterPrice;
    } else if (this.openFromCostCenterPrice == "editRemissionDetail") {
      this.getUpdateListDetail();
    }
  }

  async getFilesToRemission() {
    try {
      this.listFiles = await firstValueFrom(this.remissionService.getFilesToRemission(this.remissionId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.companyId = response.companyId;
      await this.getBranch(response.branchId, false);
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario.', error);
    }
  }

  async getFreightByRemission(costCenterId: number, VehicleId: number) {
    if (VehicleId != null && costCenterId != null) {
      /*recupera un flete segun typeVehicle dentro de los registro de obra sino buscara en fletes generales de las mismas
      condiciones de ubicacion de la obra
      */
      try {
        const freight = await firstValueFrom(this.freightService.getFreightByDocumentRental(costCenterId, VehicleId));
        if (freight) {
          this.formRemission.controls["transportValue"].setValue(freight.value);
          this.changeTransportValue();
        } else {
          this.toastHandlerService.showToast('info', 'No se ha definido valor de flete para el lugar de destino de la obra seleccionada.', 'Atención');
          this.formRemission.controls['transportValue'].setValue(0);
        }
      } catch (error) {
        console.error('Error al consultar la remisión:', error);
      }
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.remission));
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swModuleOrder = response.some(x => x.generalParameterId === GeneralParameterEnums.moduloPedidos);
      this.swFreight = response.some(x => x.generalParameterId === GeneralParameterEnums.generaFletes);
      this.swIncludeStore = response.some(x => x.generalParameterId === GeneralParameterEnums.ImprimirBodegaDocumento);
      this.swIndicators = response.some(x => x.generalParameterId === GeneralParameterEnums.indicadores);
      this.swAppMovil = response.some(x => x.generalParameterId === GeneralParameterEnums.appMovil);
    });
    this.listObservers.push(load);
  }

  getOpenFromCostCenterPrice(openFrom: string) {
    this.openFromCostCenterPrice = openFrom;
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }

    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getGeneralParametersByCompany(),
      this.getPermissionPrint()
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Remission));
  }

  async getInvoicingCutoff(invoicingCutoffId: number | null) {
    if (invoicingCutoffId != null) {
      const response = await firstValueFrom(this.invoicingCutoffService.getConsecutiveInvoicingCutoff(invoicingCutoffId));
      this.invoicingCutoffCode = response.label;
    } else {
      this.invoicingCutoffCode = '';
    }
  }

  async getRentalPeriod(rentalPeriodId: number) {
    if (rentalPeriodId == 0) { return; }
    const response = await firstValueFrom(this.rentalPeriodService.getRentalPeriodWithState(rentalPeriodId));
    this.stateRentalPeriod = response.state
    this.rentalPeriod = `${response.year}-${response.period} - ${response.stateName}`;
  }

  async getRemissionPrint() {
    try {
      this.remissionPrintModel = await firstValueFrom(this.remissionService.getRemissionByKeysByPrint(this.branchId, 0, this.remissionId));
    } catch (error) {
      console.error("Error al obtener la remisión:", error);
      this.remissionPrintModel = new RemissionPrintModel();
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.remissionService.getPermissionPrint());
    } catch (error) {
      console.error('Error to get permission print.', error);
    }
  }

  async getTransporter(transporterId: number | null) {
    const previousTransporterId = this.remissionContract.transporterId;
    if (previousTransporterId === transporterId) {
      return;
    }

    if (transporterId !== null) {
      if (this.quantityDetails !== 0) {
        const accepted = await this.confirmDialogService.confirm(`La remisión tiene artículos asociados. ¿Realmente desea modificar el transportador?`);

        if (accepted) {
          this.setTransporterId(transporterId);
        } else {
          this.setTransporterId(previousTransporterId);
        }
      } else {
        this.setTransporterId(transporterId);
      }
      setTimeout(() => this.formRemission.controls["swBlock"].disable(), 100);
    }
  }

  async setTransporterId(transporterId: number | null) {
    if (transporterId) {
      const transporter = await firstValueFrom(this.transporterService.getTransporterById(transporterId));
      transporterId = transporter.transporterId;
    }
    this.formRemission.controls["transporterId"].patchValue(transporterId);
    this.disabledDetail = true;
    this.disabledState = true;
  }

  async getQuantityDetails() {
    return await firstValueFrom(this.remissionDetailService.getQuantityDetail(this.remissionId));
  }

  async getRemissionById() {
    try {
      this.remissionContract = await firstValueFrom(this.remissionService.getRemissionById(this.remissionId));
      this.remissionId = this.remissionContract.remissionId;
      await this.validateForm(this.remissionContract);
    } catch (error) {
      console.error('Error al buscar la remisión.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/remission']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  getUpdateListDetail() {
    this.updateListDetail = !this.updateListDetail;
  }

  async getVehicle(vehicleId: number | null) {
    const previousVehicleId = this.remissionContract.vehicleId;
    if (previousVehicleId === vehicleId) {
      return;
    }

    if (vehicleId !== null) {
      if (this.quantityDetails !== 0) {
        const accepted = await this.confirmDialogService.confirm(`La remisión tiene artículos asociados. ¿Realmente desea modificar el vehículo?`);

        if (accepted) {
          this.setVehicleId(vehicleId, true);
        }
        else {
          this.setVehicleId(previousVehicleId, true);
        }
      } else {
        this.setVehicleId(vehicleId, true);
      }
    }
    else {
      this.setVehicleId(vehicleId, true);
    }
    setTimeout(() => this.formRemission.controls["swBlock"].disable(), 100);
  }

  async setVehicleId(vehicleId: number | null, onChange: boolean) {
    if (vehicleId) {
      const vehicle = await firstValueFrom(this.vehicleService.getVehicleById(vehicleId));
      const costCenterId = this.formRemission.get("costCenterId")?.value;
      this.formRemission.controls["vehicleId"].patchValue(vehicle.vehicleId);
      if (this.swFreight && onChange) this.getFreightByRemission(costCenterId, vehicle.vehicleId!);
    } else {
      this.formRemission.controls["vehicleId"].patchValue(null);
    }
    this.disabledDetail = true;
    this.disabledState = true;
  }

  async openAttachFile() {
    if (this.remissionContract.remissionId != 0 && this.remissionContract.remissionId != null) {
      await this.getFilesToRemission();
      this.attachFileRemissionComponent && this.attachFileRemissionComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una remisión.', 'Atención');
    }
  }

  async onSave() {
    if (!this.formRemission.valid) {
      this.showValidationMessages();
      return;
    }
    try {
      const branchId = this.formRemission.get("branchId")?.value;
      const response = await firstValueFrom(this.remissionService.hasExistingRemission(branchId));
      if (!response) {
        this.initialConsecutiveModalComponent?.show();
        return;
      }
      await this.send();
    } catch (error) {
      console.error('Error al buscar la ultima remisión.', error);
    }
  }

  openModalCostCenterPriceRegister() {
    this.openCostCenterPriceRegister = !this.openCostCenterPriceRegister;
  }

  async printPage() {
    if (!this.validations()) return;

    if (!this.permissionPrint) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para imprimir remisiones.', 'Atención');
      return;
    }
    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir la remisión, no tiene ningún detalle', 'Atención');
      return;
    }

    const quantityDetail = await this.getQuantityDetails();
    if (quantityDetail > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir la remisión, existen artículos con cantidad en cero o negativo', 'Atención');
      return;
    }
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getRemissionPrint();
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
    await this.updateStatePrintRemission();
  }

  async resetRemission(branchId: number) {
    this.remissionId = 0;
    this.remissionContract = new RemissionModel();
    this.remissionContract.branchId = branchId;
    this.quantityDetails = 0;
    this.invoicingCutoffCode = '';
    this.constructionSiteStateId = 0;
    this.clientStateId = 0;
    await this.validateForm(this.remissionContract);
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.remissionId != 0 && this.remissionId != null) {
      this.router.navigate(['/remission/register/', this.remissionId]);
    } else {
      this.router.navigate(['/remission/register']);
    }
  }

  async send() {
    if (this.formRemission.valid) {
      this.formRemission.controls['consecutive'].enable();
      this.formRemission.enable();

      const modelRemission = this.formRemission.getRawValue();

      //Hago null, los campos que permiten ser nulos:
      modelRemission.alterNumber = modelRemission.alterNumber || null;
      modelRemission.invoicingCutoffId = modelRemission.invoicingCutoffId || null;
      modelRemission.wildcard = modelRemission.wildcard || null;
      modelRemission.wildcard2 = modelRemission.wildcard2 || null;
      modelRemission.printObservation = modelRemission.printObservation || null;
      modelRemission.observation = modelRemission.observation || null;
      modelRemission.userId = modelRemission.userId || null;

      if (this.remissionId == 0) {
        try {
          this.remissionContract = await firstValueFrom(this.remissionService.createRemission(modelRemission));
          this.toastHandlerService.showToast('success', 'La remisión fue creada exitosamente', '');
          this.remissionId = this.remissionContract.remissionId;
          await this.validateForm(this.remissionContract);
          this.location.replaceState(`/remission/register/${this.remissionId}`);
        } catch (error) {
          console.error('Error al crear la remisión.', error);
          this.updateFormState();
          setTimeout(() => this.formRemission.controls["consecutive"].patchValue(0));
          setTimeout(() => this.formControlStateService.setControlState(
            this.formRemission,
            ['observationCostCenter', 'swInvoiceM2', 'unitValueM2'],
            false
          ), 100);
        }
      } else {
        try {
          this.remissionContract.alterNumber = modelRemission.alterNumber;
          this.remissionContract.costCenterId = modelRemission.costCenterId;
          this.remissionContract.dateRemission = modelRemission.dateRemission;
          this.remissionContract.dateInvoice = modelRemission.dateInvoice;
          this.remissionContract.transportValue = modelRemission.transportValue;
          this.remissionContract.transportValuePay = modelRemission.transportValuePay;
          this.remissionContract.transporterId = modelRemission.transporterId;
          this.remissionContract.vehicleId = modelRemission.vehicleId;
          this.remissionContract.wildcard = modelRemission.wildcard;
          this.remissionContract.wildcard2 = modelRemission.wildcard2;
          this.remissionContract.printObservation = modelRemission.printObservation;
          this.remissionContract.observation = modelRemission.observation;
          this.remissionContract.compromiseDate = modelRemission.compromiseDate;
          this.remissionContract.conceptTypeRequirementId = modelRemission.conceptTypeRequirementId;
          this.remissionContract.conceptDelayReasonId = modelRemission.conceptDelayReasonId;
          this.remissionContract.conceptTypeAvailabilityId = modelRemission.conceptTypeAvailabilityId;
          this.remissionContract.userId = modelRemission.userId;

          this.remissionContract = await firstValueFrom(this.remissionService.updateRemission(this.remissionContract));
          this.toastHandlerService.showToast('success', 'La remisión fue modificada exitosamente', '');
          await this.validateForm(this.remissionContract);
        } catch (error) {
          console.error('Error al actualizar la remisión.', error);
          this.updateFormState();
          setTimeout(() => this.formControlStateService.setControlState(this.formRemission,
            ['observationCostCenter', 'swInvoiceM2', 'unitValueM2'],
            false
          ), 100);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo sucursal es obligatorio.',
        min: 'Debes seleccionar una sucursal válida.'
      },
      alterNumber: {
        max: 'El valor máximo del número alterno es 9999999'
      },
      costCenterId: {
        required: 'El campo centro de costos es obligatorio.',
        min: 'Debes seleccionar un centro de costos válido.'
      },
      dateRemission: {
        required: 'El campo fecha remisión es obligatorio.'
      },

      dateInvoice: {
        required: 'El campo fecha factura es obligatorio.'
      },
      remissionStateId: {
        required: 'El campo estado es obligatorio.'
      },
      transportValue: {
        required: 'El campo valor del transporte a cobrar es obligatorio.',
        min: 'El valor mínimo del transporte a cobrar es 0.',
        max: 'El valor máximo del transporte a cobrar es 99999999999.99'
      },
      transportValuePay: {
        required: 'El campo valor del transporte a pagar es obligatorio.',
        min: 'El valor mínimo del transporte a pagar es 0.',
        max: 'El valor máximo del transporte a pagar es 99999999999.99'
      },
      transporterId: {
        required: 'El campo transportador es obligatorio.',
        min: 'Debes seleccionar un tranportador válido.'
      },
      vehicleId: {
        required: 'El campo vehículo es obligatorio.',
        min: 'Debes seleccionar un vahículo válido.'
      },
      wildcard: {
        maxlength: 'El campo comodín 1 permite máximo 20 .'
      },
      wildcard2: {
        maxlength: 'El campo comodín 2 permite máximo 20 .'
      },
      printObservation: {
        maxlength: 'El campo observación impresión permite máximo 250 .'
      },
      observation: {
        maxlength: 'El campo observación permite máximo 250 .'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formRemission.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.remissionService.attachFilesToRemission(this.remissionId, formData));
      await this.getFilesToRemission();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  updateFormPermision() {
    switch (this.remissionContract.remissionStateId) {
      case RemissionStateEnums.open: {
        this.remissionStateString = "Abierto";
        break;
      }
      case RemissionStateEnums.annulled: {
        this.remissionStateString = "Anulado";
        break;
      }
      case RemissionStateEnums.finalClose: {
        this.remissionStateString = "Cierre Final";
        break;
      }
      case RemissionStateEnums.printed: {
        this.remissionStateString = "Impreso";
        break;
      }
    }
    this.disabledDetail = true;
    this.disabledForm = true;
    this.disabledBtnSave = true;
    this.disabledState = true;
    this.visibleState = true;
    setTimeout(() => this.formRemission.disable(), 100);
    setTimeout(() => this.formRemission.controls["consecutive"].enable(), 100);
  }

  updateFormState() {
    const stateConfig: any = {
      [RemissionStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.remissionId !== 0,
      },
      [RemissionStateEnums.finalClose]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cierre Final',
        isDisabled: true,
        enableConsecutive: true,
      },
      [RemissionStateEnums.annulled]: {
        severity: 'warn',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulado',
        isDisabled: true,
        enableConsecutive: true,
      },
      [RemissionStateEnums.printed]: {
        severity: 'info',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impreso',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.remissionContract.remissionStateId;
    const config = stateConfig[currentState];
    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledBtnSave = config.isDisabled;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = this.remissionContract.remissionId == 0 ? true : config.isDisabled;

      setTimeout(() => {
        if (this.remissionContract.swBlock) {
          this.formRemission.disable();
          this.disabledDetail = true;
          this.disabledForm = true;
          this.disabledBtnSave = true;
        } else {
          config.isDisabled ? this.formRemission.disable() : this.formRemission.enable();
        }
        const control = this.formRemission.controls["consecutive"];
        config.enableConsecutive ? control.enable() : control.disable();
        this.formRemission.controls["swBlock"].enable();
      }, 100);
    }

    //Habilita el campo de fecha de facturacion cuando el periodo este cerrado y no este en corte
    if (this.remissionContract.rentalPeriod?.active == false && this.remissionContract.invoicingCutoff == null && !this.remissionContract.swBlock &&
      this.remissionContract.remissionStateId != RemissionStateEnums.annulled) {
      setTimeout(() => this.formRemission.controls["dateInvoice"].enable(), 100);
      this.disabledBtnSave = true;
    }

    if (!this.permissionUpdatable) setTimeout(() => this.formRemission.disable(), 100);
    setTimeout(() => this.formRemission.controls["branchId"].enable(), 100);
  }


  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.remissionContract.consecutive,
      disabled: this.remissionContract.remissionStateId != RemissionStateEnums.open
    });
  }


  async updateStatePrintRemission() {
    try {
      this.remissionContract = await firstValueFrom(this.remissionService.updateStatePrintRemission(this.remissionContract.remissionId));
      await this.validateForm(this.remissionContract);
    } catch (error) {
      console.error('Error al actualizar el estado a impresa', error)
    }
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar remisiones. Comuníquese con el administrador del sistema.'
      );
      return false;
    }

    if (this.remissionContract.remissionId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado de la remisión.'
      );
      return false;
    }
    return true;
  }

  setListUsersApp(savedUserId: number | null) {
    this.listUsersApp = this.listUsersAppSource.map(x => ({
      ...x,
      disabled: x.disabled && x.value !== savedUserId
    }));
  }

  async validateForm(remission: RemissionModel) {
    this.formRemission = this.formBuilder.group({
      branchId: [remission.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [remission.consecutive, []],
      alterNumber: [remission.alterNumber, [Validators.max(9999999)]],
      costCenterId: [remission.costCenterId, [Validators.required, Validators.min(1)]],
      clientId: [],
      observationCostCenter: [],
      swInvoiceM2: [],
      unitValueM2: [],
      dateRemission: [remission.dateRemission ?
        this.dateConverterService.convertUtcToLocalDate(remission.dateRemission) : null, [Validators.required]],
      rentalPeriodId: [remission.rentalPeriodId, [Validators.required]],
      dateInvoice: [remission.dateInvoice ?
        this.dateConverterService.convertUtcToLocalDate(remission.dateInvoice) : null, [Validators.required]],
      remissionStateId: [remission.remissionStateId, [Validators.required]],
      swBlock: [remission.swBlock, []],
      invoicingCutoffId: [remission.invoicingCutoffId, []],
      transportValue: [remission.transportValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      transportValuePay: [remission.transportValuePay, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      transporterId: [remission.transporterId, [Validators.required, Validators.min(1)]],
      vehicleId: [remission.vehicleId, [Validators.required, Validators.min(1)]],
      wildcard: [remission.wildcard, [Validators.maxLength(20)]],
      wildcard2: [remission.wildcard2, [Validators.maxLength(20)]],
      printObservation: [remission.printObservation, [Validators.maxLength(250)]],
      observation: [remission.observation, [Validators.maxLength(250)]],
      compromiseDate: [remission.compromiseDate ?
        this.dateConverterService.convertUtcToLocalDateFull(remission.compromiseDate) : null],
      conceptTypeRequirementId: [remission.conceptTypeRequirementId],
      conceptDelayReasonId: [remission.conceptDelayReasonId],
      conceptTypeAvailabilityId: [remission.conceptTypeAvailabilityId],
      userId: [remission.userId],
    });
    this.setListUsersApp(remission.userId);

    if (remission.remissionId == 0) {
      if (this.mainBranchByUser.branchId != 0) this.getBranch(this.mainBranchByUser.branchId, false);
    } else {
      await Promise.all([
        this.getCostCenter(remission.costCenterId, false),
        this.setTransporterId(remission.transporterId),
        this.setVehicleId(remission.vehicleId, false),
        this.getRentalPeriod(remission.rentalPeriodId),
        this.getInvoicingCutoff(remission.invoicingCutoffId)
      ])
    }
    this.updateFormState();

    setTimeout(() => this.formControlStateService.setControlState(
      this.formRemission,
      ['observationCostCenter', 'swInvoiceM2', 'unitValueM2'],
      false
    ), 100);
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();

          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }

}
